import { render, staticRenderFns } from "./AppDraggable.vue?vue&type=template&id=4a73d716&scoped=true"
import script from "./AppDraggable.vue?vue&type=script&lang=ts"
export * from "./AppDraggable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73d716",
  null
  
)

export default component.exports